module.exports = __webpack_public_path__ + "static/img/54.cf29f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Microsoft365Security/54.png
// module id = h4vo
// module chunks = 1